import { FC } from 'react';
import styled from '@emotion/styled';
import { Stack, Typography } from '@mui/material';
import { formatDateTimePartsLocal } from '@/components/Focus/utils/newScheduleAvails';
import { FocusTheme } from '../configs/theme';

export type SchedulingTermDateProps = {
  label: string;
  value: string;
  locale?: string;
};

const SchedulingTermDate: FC<SchedulingTermDateProps> = ({ label, value, locale = 'en-US' }) => {
  if (!value) {
    return (
      <Stack spacing={0}>
        <StyledLabelSpacer />
        <EmptyValue>-</EmptyValue>
        <StyledTimeSpacer />
      </Stack>
    );
  }

  const { date, time } = formatDateTimePartsLocal(value, locale, 'short');

  return (
    <Stack spacing={0}>
      <StyledLabel>{label}</StyledLabel>
      <StyledDate>{date}</StyledDate>
      <StyledTime>{time}</StyledTime>
    </Stack>
  );
};

export default SchedulingTermDate;

const StyledLabel = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(11)};
  color: ${({ theme }) => theme.palette.primary.light};
  line-height: 1.2;
  white-space: nowrap;
`;

const StyledLabelSpacer = styled.span`
  min-height: ${({ theme }) => theme.typography.pxToRem(13.2)};
`;

const StyledDate = styled(Typography)`
  font-weight: 700;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[10]};
  white-space: nowrap;
`;

const EmptyValue = styled(StyledDate)`
  display: inline-flex;
  justify-content: center;
  min-width: 75px;
`;

const StyledTime = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[30]};
  white-space: nowrap;
`;

const StyledTimeSpacer = styled.span`
  min-height: ${({ theme }) => theme.typography.pxToRem(18)};
`;
